module.exports = __webpack_public_path__ + "media/images/games/fifa-23/background-c6f62839e51b65704a6e29ccaa100f34.jpg";